module.exports = __webpack_public_path__ + "static/media/codigo.c660dd60.svg";